import { render, staticRenderFns } from "./belt.vue?vue&type=template&id=a8ad3696&scoped=true&"
import script from "./belt.vue?vue&type=script&lang=js&"
export * from "./belt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ad3696",
  null
  
)

export default component.exports